export const mensagemErro = (e) => e.response?.data?.message || e.message || 'Não foi possível concluir a operação.';
export const vazio = (v) => v == null || String(v).trim() === '';
export const nulo = (v) => (vazio(v) ? null : v);
export const dataBR = (v) => (v ? String(v).slice(0, 10).split('-').reverse().join('/') : '—');
export const hoje = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const nomeBem = (b) => b?.pocoIdentificacao || b?.descricao || b?.produtoBens?.descricao || 'Poço';
export const nomeOutorga = (o) =>
    `${o.numeroPortaria} • v${o.versao} • ${o.situacao} • ${dataBR(o.vigenciaInicio)} a ${dataBR(o.vigenciaFim)}`;
export const nomeMedidor = (m) => `${m.identificacao} (${m.numeroSerie || 'sem série'})${m.retiradoEm ? ' • retirado' : ''}`;
export function decimal(v, casas = 3) {
    if (vazio(v)) return null;
    const text = String(v).trim().replace(',', '.');
    if (!new RegExp(`^\\d+(?:\\.\\d{1,${casas}})?$`).test(text))
        throw new Error(`Informe número positivo, sem separador de milhar e com até ${casas} casas decimais.`);
    return text; // Mantém precisão: nunca converter leitura para Number/parseFloat.
}
export function isoLocal(v) {
    if (vazio(v)) return null;
    const d = new Date(v);
    if (!Number.isFinite(d.getTime())) throw new Error('Data/hora inválida.');
    return d.toISOString();
}
export function payloadMedicao(dados, original = {}) {
    const body = {};
    for (const key of [
        'dataMedicao',
        'horaMedicao',
        'medidorAguaId',
        'medidorEnergiaId',
        'lacreAguaId',
        'bombeamentoMinutos',
        'observacao',
        'motivo',
    ])
        body[key] = nulo(dados[key]);
    for (const key of ['leituraAgua', 'leituraEnergia']) body[key] = decimal(dados[key]);
    for (const [key, flag, origin] of [
        ['volumeExtraidoM3', 'informarVolume', 'origemVolume'],
        ['energiaConsumidaKwh', 'informarEnergia', 'origemEnergia'],
    ]) {
        const wasManual = ['INFORMADO', 'IMPORTADO'].includes(original[origin]);
        if (dados[flag]) {
            const value = decimal(dados[key]);
            if (value == null) throw new Error('Preencha o consumo informado ou desmarque a opção de informar manualmente.');
            // Preserva a origem IMPORTADO e valores derivados em edições que não alteram esse campo.
            if (!original.uuid || !wasManual || String(dados[key]) !== String(original[key])) body[key] = value;
        } else if (wasManual) body[key] = null; // Volta à apuração pelo servidor.
    }
    if (dados.informarVolume || dados.informarEnergia) {
        body.intervaloInicio = nulo(dados.intervaloInicio);
        body.intervaloFim = nulo(dados.intervaloFim);
    } else if (
        ['INFORMADO', 'IMPORTADO'].includes(original.origemVolume) ||
        ['INFORMADO', 'IMPORTADO'].includes(original.origemEnergia)
    ) {
        body.intervaloInicio = null;
        body.intervaloFim = null;
    }
    if (original.uuid) {
        body.uuid = original.uuid;
        body.updatedAt = original.updatedAt;
    } else body.produtoBensId = dados.produtoBensId;
    return body;
}
